<template>
  <div class="upload-marital-material">
    <div class="title" >
      {{marital.elec_name}}

      <fliggy-select-file-btn
        v-if="!forbidUpload"
        class="m-l-20"
        :order="order"
        :applicant="applicant"
        :material-name="marital.elec_name"
        :max-select-num="1"
        :support-pdf="true"
        @confirm="onUploadByFliggy"
      ></fliggy-select-file-btn>
    </div>

    <div class="upload-content">
      <!-- 特殊状态 -->
      <el-radio-group v-model="applicant.marital_status" @change="changeMaritalStatus">
        <el-radio class="radio" :label="k" v-for="(v,k) in maritalStatus" :key="k" v-if="k>0" :disabled="disableMaritalRadio">{{v}}</el-radio>
      </el-radio-group>

      <!-- 资料不完善备注 -->
      <memo class="memo" v-if="isMaritalNoNeedUploadImage && marital.upload[0].memo" :memo-content="marital.upload[0].memo"></memo>

      <div class="upload-box">

        <!-- 上传 -->
        <upload-item :pdf="true" class="upload-item" :img-url="marital.upload[0].url" :upload="marital.upload[0]" :forbid="forbidUpload"
          :verify-passed="marital.upload[0].elec_status === consts.ELEC_STATUS.qualified_0"
          :verify-not-pass="marital.upload[0].elec_status === consts.ELEC_STATUS.unqualified_3"
          :is-reupload="isReupload"
          :file-name="`${marital.elec_name}.pdf`"
          @uploadFile="uploadMaritalFile" @reviewImage="reviewImage"></upload-item>

        <!-- 分割线 -->
        <div class="dashed-line"></div>

        <!-- 示例 -->
        <sample class="sample-box" v-if="sampleUrl" :sample-url="sampleUrl" @click.native="reviewImage(sampleUrl)"></sample>

        <!-- 注意事项 -->
        <attention class="attention-box" :attention="marital.attention"></attention>
      </div>

      <!-- 资料不完善备注 -->
      <memo class="memo" v-if="!isMaritalNoNeedUploadImage && marital.upload[0].memo" :memo-content="marital.upload[0].memo"></memo>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import uploadItem from './upload-item';
import attention from './attention';
import memo from './memo';
import sample from './sample';
import status from '../../libs/status';
import Http from '../../libs/http';
import materialConstants from '../../constants/material-constants';
import uploadFileService from '../../services/upload-file-service';
import uploadService from '../../services/upload-service';
import applicantConstants from '../../constants/applicant-constants';
import marriedSampleUrl from '../../assets/imgs/upload/married-sample.png';
import divorceSampleUrl from '../../assets/imgs/upload/divorce-sample.png';
import fileService from '../../services/file-service';
import FliggySelectFileBtn from './ota/fliggy-select-file-btn.vue';

export default {
  name: 'uploadMaritalMaterial',
  components: {
    attention,
    uploadItem,
    memo,
    sample,
    FliggySelectFileBtn,
  },
  props: {
    marital: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    isReupload: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      marriedSampleUrl,
      divorceSampleUrl,
      maritalStatus: status.maStatus, // 所有婚姻状态
      consts: {
        ELEC_STATUS: materialConstants.ELEC_STATUS,
      },
    };
  },
  computed: {
    sampleUrl() {
      if (
        +this.applicant.marital_status ===
        materialConstants.MARITAL_STATUS.married_2
      ) {
        return this.marriedSampleUrl;
      }
      if (
        +this.applicant.marital_status ===
        materialConstants.MARITAL_STATUS.divorced_3
      ) {
        return this.divorceSampleUrl;
      }
      return '';
    },

    // 是否可以上传
    forbidUpload() {
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return this.isMaritalNoNeedUploadImage;
        }

        const isApplicantVerifyNotPass =
          this.applicant.applicant_status ===
          applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，不能上传
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        // 一项都没有的时候需要禁用上传(出现在用户下单的时候没有上传资料，资料不完善的时候也没有需补充资料，但是此时需要展示，且不能上传)
        const isEmptyUpload = Boolean(!this.marital.upload[0].url);
        const isTempUpload = Boolean(this.marital.upload[0].temp);
        // const maritalWaittingForVerify = this.marital.upload[0].elec_status === 2;
        const isMaritalUploadSpecial = this.marital.upload[0].special_code > 0;

        // 需要上传的状态
        if (!this.isMaritalNoNeedUploadImage) {
          // 如果是临时的上传，就禁用
          if (isTempUpload) {
            return true;
          }

          // upload中是有特殊状态标识的，如果是使用初始化方法初始化的是没有特殊状态的
          if (isMaritalUploadSpecial) {
            // 如果这个时候是空的
            if (isEmptyUpload) {
              // 就不禁用
              return false;
            }
          }
        }
      }

      // 还没选婚姻状态
      if (
        +this.applicant.marital_status ===
        materialConstants.MARITAL_STATUS.unknown_0
      ) {
        return true;
      }

      // 需要上传图片的婚姻状态

      // 婚姻资料不需要要上传
      const isMaritalNoNeedUploadImage = this.isMaritalNoNeedUploadImage;

      // 下单的时候
      if (!this.isReupload) {
        return isMaritalNoNeedUploadImage;
      }
      // 重新上传的时候
      // 婚姻资料预审通过了
      const isMaritalVerifyPassed =
          this.marital.upload[0].elec_status ===
          materialConstants.ELEC_STATUS.qualified_0;
      return isMaritalNoNeedUploadImage || isMaritalVerifyPassed;
    },

    // 婚姻状况，选择特殊情况或上传图片，资料合格后，无论在任何申请人状态下，资料都不可编辑，选框禁选、保存按钮隐藏
    disableMaritalRadio() {
      // 重新上传才有禁用的情况
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        // 一项都没有的时候需要禁用上传(出现在用户下单的时候没有上传资料，资料不完善的时候也没有需补充资料，但是此时需要展示，且不能上传)
        const isEmptyUpload = Boolean(!this.marital.upload[0].url);
        const isTempUpload = Boolean(this.marital.upload[0].temp);
        const maritalWaittingForVerify =
          this.marital.upload[0].elec_status === 2;
        const applicantVerifyNotPass =
          this.applicant.applicant_status ===
          applicantConstants.STATUS.verifyNotPassed_2;
        // const isMaritalSpecial = this.marital.upload[0].special_code > 0;
        const maritalVerifyPassed = this.marital.upload[0].elec_status === 0;
        const maritalVerifyNotPassed = this.marital.upload[0].elec_status === 3;

        // 是需要上传图片的婚姻状态
        if (!this.isMaritalNoNeedUploadImage) {
          // 如果是临时上传项目
          if (isTempUpload && isEmptyUpload) {
            return true;
          }

          // 如果是待上传或者资料不完善
          if (maritalWaittingForVerify || maritalVerifyNotPassed) {
            // 如果是空的上传项
            if (isEmptyUpload) {
              // 就不禁用
              return false;
            }
          }
        }

        // 资料合格了就不能操作了
        if (maritalVerifyPassed) {
          return true;
        }
        // 申请人资料不完善
        if (applicantVerifyNotPass) {
          // 可以操作
          return false;
        }
        // 否则不能
        return true;
      }

      return false;
    },

    // 婚姻不需要上传资料
    isMaritalNoNeedUploadImage() {
      // 不需要上传图片的婚姻状态
      const needUploadImageMaritalStatusArr = [
        materialConstants.MARITAL_STATUS.unmarried_1,
        materialConstants.MARITAL_STATUS.widowed_4,
      ];

      return _.includes(needUploadImageMaritalStatusArr, +this.applicant.marital_status);
    },
  },
  methods: {
    // 更新婚姻状态
    updateMaritalStatus(parsed_marital_status) {
      return Http.post('/applicant_marital_status_add', {
        user_order_id: this.applicant.user_order_id,
        order_applicant_id: this.applicant.order_applicant_id,
        elec_id: this.marital.elec_id,
        marital_status: parsed_marital_status,
      });
    },

    // 处理婚姻状态的特殊情况
    specialHandleMarital(special_code) {
      return Http.post('/applicant_elec_special_handle', {
        user_order_id: this.applicant.user_order_id,
        order_applicant_id: this.applicant.order_applicant_id,
        elec_id: this.marital.elec_id,
        special_code,
      });
    },

    // 修改婚姻状态
    changeMaritalStatus() {
      // 转为数字
      const parsed_marital_status = +this.applicant.marital_status;

      // 不需要上传图片的婚姻状态
      const needSpecialHandleMaritalStatusArr = [
        materialConstants.MARITAL_STATUS.unmarried_1,
        materialConstants.MARITAL_STATUS.widowed_4,
      ];
      if (needSpecialHandleMaritalStatusArr.indexOf(parsed_marital_status) > -1) {
        // 更新婚姻状态
        this.updateMaritalStatus(parsed_marital_status).then(() => {
          // 未婚和丧偶
          // 拿到特殊码
          const special_code =
          parsed_marital_status ===
          materialConstants.MARITAL_STATUS.unmarried_1
            ? materialConstants.SPECIAL_CODE.unmarried_3
            : materialConstants.SPECIAL_CODE.widowed_4;

          // 重新上传
          if (this.isReupload) {
          // 如果更新为其他不需要上传的婚姻类型，则需要将资料状态变为待预审
            this.marital.upload[0].elec_status =
            materialConstants.ELEC_STATUS.waittingForVerified_2;
            this.marital.upload[0].memo = '';
          }

          // 特殊状态设置
          this.specialHandleMarital(special_code).then(() => {
            this.marital.upload[0].special_code = special_code;
            this.marital.upload[0].url = '';
          }).catch((e) => {
            if (e) console.log(e);
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {
        this.marital.upload[0].url = '';
      }
    },

    // 上传婚姻资料
    uploadMaritalFile(file) {
      this.marital.upload[0].file = file;
      this.marital.upload[0].url = URL.createObjectURL(file);

      // 设置loading状态
      this.$set(this.marital.upload[0], 'loading', true);
      uploadFileService.uploadFile(file, false, { noKey: true }).then((res) => {
        this.photoKeyUploadSinglePage(res);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 飞猪资料上传
    onUploadByFliggy({ key_list }) {
      const key = key_list[0];
      // 设置loading状态
      this.$set(this.marital.upload[0], 'loading', true);
      this.marital.upload[0].url = fileService.getOssFullUrl(key);
      this.photoKeyUploadSinglePage(key);
    },

    // 照片KEY上传到单页上
    photoKeyUploadSinglePage(key) {
      const dowloadName = `${this.applicant.applicant_name}${this.marital.elec_name}.pdf`;
      uploadFileService.doUpload(this.marital, this.marital.upload[0], this.applicant.user_order_id, this.applicant.order_applicant_id, key, dowloadName).then(() => {
        this.updateMaritalStatus(+this.applicant.marital_status);

        // 资料不完善
        if (this.isReupload) {
          this.marital.upload[0].memo = '';
          this.marital.upload[0].elec_status =
              materialConstants.ELEC_STATUS.waittingForVerified_2;
          this.marital.upload[0].special_code = 0;
        }
      }).catch((e) => {
        if (e) console.log(e);
        // 感觉timeout一下没有那么突兀
        setTimeout(() => {
          this.marital.upload[0].url = '';
        }, 1000);
      });
    },

    // 预览图片
    reviewImage(imageSrc) {
      this.$emit('reviewImage', imageSrc);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.upload-marital-material {
  line-height: 1;
  background-color: #fff;
  .title {
    padding: 30px 30px 20px 30px;
    display: flex;
    align-items: center;
  }
  .upload-content {
    padding: 0 30px 30px 30px;
    .upload-box {
      margin-top: 20px;
      display: flex;
      .upload-item {
        width: 200px;
        height: 130px;
      }
      .dashed-line {
        width: 1px;
        height: 130px;
        background-color: white;
        border-right: 1px dashed @border;
        margin-left: 50px;
      }
      .sample-box {
        margin-left: 50px;
        height: 130px;
      }
      .attention-box {
        margin-left: 30px;
        flex: 1;
      }
    }
    .memo {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-marital-material.vue